module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("To my agent, David Gernert."), _c('br'), _vm._v("This is the tenth DeMarco novel and were it not for David, "), _c('br'), _vm._v("the first one would never have been published. Words cannot "), _c('br'), _vm._v("express how much I appreciate all he’s done for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("House Rivals")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024296de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_4345-4.vue
// module id = 75
// module chunks = 0